An opaque cursor to the later bounding webhook request.

Resulting webhook requests will _precede_ this cursor.
